<template>
  <div class="fluid-container">
    <div class="hello row">
      <div class="col-1 col-md-1"></div>
      <div class="col-11 col-md-4 infoDiv">
        <h1 class="titre">Brigida Bocini</h1>
        <p class="infos">
          Studio: Usine Parker, rue Jacques-Grosselin 50 C, 1227 Carouge, CH
        </p>
        <a href="mailto:brigidabocini@gmail.com">Contact</a><br />
        <a href="/bocini-brigida_PORTFOLIO_CV.pdf" target="_blank">Portfolio / CV</a>
        <br /><br />
      </div>
      <div class="col-md-1 d-sm-none d-md-block hiddenBlock"></div>
      <div class="w-100 d-md-none hiddenBlock"></div>
      <div class="col-1 d-md-none"></div>
      <div class="col-11 col-md-5">
        <table>
          <tbody>
            <tr>
              <td class="year"><h1 class="latest">Latest</h1></td>
            </tr>
            <tr>
              <td class="year">2024</td>
              <td class="cell">
                <a class="linkExpo" target="_blank" href="https://2024.p-a-g-e-s.ch/fr/">
                  <i>Red-eye Effect, P.a.g.e.s.</i> w. Medium Sans, Espace Hippomène, Geneva, CH
                </a>
              </td>
            </tr>
            <tr>
              <td class="year">2023</td>
              <td class="cell">
                <a class="linkExpo" target="_blank" href="https://ateliersportesouvertes.ch/exposant/brigida-bocini">
                  Ateliers portes ouvertes, Usine Parker, Geneva, CH
                </a>
              </td>
            </tr>
            <tr>
              <td class="year">2023</td>
              <td class="cell">
                <a class="linkExpo" target="_blank" href="https://comunicati.comune.prato.it/generali/?action=dettaglio&comunicato=14202300000426">
                  Talk w. Estuario Project Space, Officina Giovani, Prato, IT
                </a>
              </td>
            </tr>
            <tr>
              <td class="year">2021</td>
              <td class="cell">
                <a class="linkExpo" target="_blank" href="https://aduplex.ch/evenements/aduplex-mille-vues-du-saleve-c-est-possible-dit-la-mouche">
                  <i>àDuplex Mille vues du Salève c'est Possible, dit « la Mouche »</i>, àDuplex, Geneva, CH
                </a>
              </td>
            </tr>
            <tr>
              <td class="year">2020</td>
              <td class="cell">
                <a class="linkExpo" target="_blank" href="https://fcac.ch/actualites/bourses-deliees-arts-visuels-2020-2/">
                  <i>Bourses Déliées 2020</i>, Fonds cantonal d'art contemporain (FCAC), Halle nord, Geneva, CH
                </a>
              </td>
            </tr>
            <tr>
              <td class="year">2020</td>
              <td class="cell">
                <a class="linkExpo" target="_blank" href="https://www.ladecadanse.ch/event/evenement.php?idE=344358&tri=dateAjout">
                  <i>Sans chemise, sans pantalon</i> (w. Sylvain Gelewski), Musée sans batiment by Yona Friedman, Sculpture Garden, Geneva Biennale, CH
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainContent',
};
</script>

<style scoped>
.fluid-container {
  position: relative;
  z-index: 10;
}
</style>